const initialState = {
    selectedTab: 'cart', // cart | nextList
    isShowMoreMenuCart: false,
    isShowMoreMenuNextList: false,
};

const checkoutCart = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_CHECKOUT_CART':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default checkoutCart;
